var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pt-6 bg-white managerProjects" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            hasData: !!_vm.projects,
            loading: _vm.$apollo.queries.projects.loading,
          },
        },
        [
          _vm.empty
            ? _c("EmptyListPlaceholder", {
                attrs: {
                  title: _vm.emptyListTitle,
                  subtitle: _vm.emptyListSubtitle,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "image",
                      fn: function () {
                        return [_c("EmptyListImageProjects")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4049957145
                ),
              })
            : [
                _c(
                  "div",
                  { staticClass: "px-6" },
                  [
                    _c("ProjectCollectionManager", {
                      attrs: {
                        projects: _vm.projects,
                        companyId: _vm.companyId,
                        currentUser: _vm.currentUser,
                        canEdit: "",
                      },
                      on: { projectUpdated: _vm.handleRefetch },
                    }),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }